<template>
  <div class="layout-container">
    <el-menu
      mode="horizontal"
      :ellipsis="false"
    >
      <div @click="top()" class="menu-column menu-logo">
        <svg xmlns="http://www.w3.org/2000/svg" id="logo" width="200px" height="55px">
          <text x="0" y="40" class="logo-txt logo-animated">COUPE DESIGN</text>
        </svg>
      </div>
      <div class="menu-column menu-translate">
        <el-switch
          v-model="translate"
          class="sw-translate"
          style="--el-switch-on-color: #cbcba0; --el-switch-off-color: #85ab96"
          active-text="日本語"
          inactive-text="EN"
        />
      </div>
    </el-menu>

    <div>
      <svg viewBox="0 0 850 100" class="catchphrase" xmlns="http://www.w3.org/2000/svg">
        <text x="50%" y="50%" text-anchor="middle" dominant-baseline="middle" font-size="72" fill="none" stroke="black" stroke-width="2" stroke-dasharray="1000" stroke-dashoffset="1000">
          {{ translate ? '進化する、ものづくり。' : 'Evolving, our products.' }}
          <animate attributeName="stroke-dashoffset" from="1000" to="0" dur="2s" begin="0s" fill="freeze" />
          <set attributeName="fill" to="black" begin="2s" />
        </text>
      </svg>
    </div>

    <el-carousel class="is-mobile" height="500px" arrow="always" :autoplay="false">
      <el-carousel-item>
        <el-main class="item-about-us">
          <AboutUs :translate="translate"></AboutUs>
        </el-main>
      </el-carousel-item>
      <el-carousel-item>
        <el-main class="item-transactions">
          <NoticeRegardingTransactions :translate="translate"></NoticeRegardingTransactions>
        </el-main>
      </el-carousel-item>
      <el-carousel-item>
        <el-main class="item-company-profile">
          <CompanyProfile :translate="translate"></CompanyProfile>
        </el-main>
      </el-carousel-item>
      <el-carousel-item v-if="translate">
        <el-main class="item-support-examples">
          <SupportExamples :translate="translate"></SupportExamples>
        </el-main>
      </el-carousel-item>
    </el-carousel>

    <el-carousel class="is-pc" height="500px" type="card" :autoplay="false">
      <el-carousel-item>
        <el-main class="item-about-us">
          <AboutUs :translate="translate"></AboutUs>
        </el-main>
      </el-carousel-item>
      <el-carousel-item>
        <el-main class="item-company-profile">
          <CompanyProfile :translate="translate"></CompanyProfile>
        </el-main>
      </el-carousel-item>
      <el-carousel-item>
        <el-main class="item-transactions">
          <NoticeRegardingTransactions :translate="translate"></NoticeRegardingTransactions>
        </el-main>
      </el-carousel-item>
      <el-carousel-item v-if="translate">
        <el-main class="item-support-examples">
          <SupportExamples :translate="translate"></SupportExamples>
        </el-main>
      </el-carousel-item>
    </el-carousel>

    <div class="item-info">

      <div v-if="translate" class="item-info-right">

        <div v-for="item, idx in todaySchedules" :key="idx" class="item-other bird">
          <img src="../assets/img/bird.svg" alt="Bird" class="bird-img">
          <div class="speech-bubble">
            <p>📅 {{ todayText }}</p>
            <p>{{item.message1 }}</p>
            <p v-if="item.message2"> {{ item.message2 }}</p>
            <p v-if="item.message3"> {{ item.message3 }}</p>
          </div>
        </div>

        <div v-if="true" class="item-other bird">
          <img src="../assets/img/bird.svg" alt="Bird" class="bird-img">
          <div class="speech-bubble">
            <p>📢 お知らせ</p>
            <p>間違い電話が多くなっております。番号をご確認ください。</p>
          </div>
        </div>

        <div class="item-staff-only">
          <p v-if="translate">関係者入口</p>
          <p v-else>Staff Only</p>
          <div class="img-staff">
            <img @click="gotoStaffPage()" src="../assets/img/staff2_150.png">
            <el-input v-model="code" style="width: 100px" placeholder="" />
          </div>
        </div>
      </div>
    </div>

    <div class="item-updated">
      <p v-if="translate">更新日: 2026.3.16</p>
      <p v-else>Updated: March 16, 2026</p>
    </div>

    <footer>
      <div v-if="translate" class="footer-content">
        <p>&copy; 2025 株式会社クープデザイン All rights reserved.</p>
      </div>
      <div v-else class="footer-content">
        <p>&copy; 2025 Coupe Design Co., Ltd. All rights reserved.</p>
      </div>
    </footer>
  </div>
</template>

<script lang="ts" setup>
import AboutUs from './AboutUs.vue';
import NoticeRegardingTransactions from './NoticeRegardingTransactions.vue';
import CompanyProfile from './CompanyProfile.vue';
import SupportExamples from './SupportExamples.vue';
import { ref, onMounted, watch, computed } from 'vue';

const translate = ref(true);
const code = ref('');

type Schedule = {
  start: string
  end: string
  message1: string
  message2: string
  message3: string
}

const holidays = [
  '2026-01-01',
  '2026-01-12',
  '2026-02-11',
  '2026-02-23',
  '2026-03-20',
  '2026-04-29',
  '2026-05-03',
  '2026-05-04',
  '2026-05-05',
  '2026-05-06',
  '2026-07-20',
  '2026-08-11',
  '2026-09-21',
  '2026-09-22',
  '2026-09-23',
  '2026-10-12',
  '2026-11-03',
  '2026-11-23'
]

 const today = new Date()

const todayStr = today.toISOString().slice(0, 10)

const isHoliday = holidays.includes(todayStr)

const week = ['日', '月', '火', '水', '木', '金', '土'][today.getDay()]

const todayText = computed(() => {
  const y = today.getFullYear()
  const m = today.getMonth() + 1
  const d = today.getDate()

  let suffix = ''
  if (isHoliday) suffix = '・祝'

  return `${y}.${m}.${d}（${week}${suffix}）`
})

const schedules: Schedule[] = [
  {
    start: '2026-03-16',
    end: '2026-03-19',
    message1: '本日は通常営業です。',
    message2: 'なお、外出やリモート作業のため担当者が不在の場合がございます。',
    message3: ''
  },
  {
    start: '2026-03-20',
    end: '2026-03-22',
    message1: '本日は休業日です。',
    message2: '',
    message3: ''
  },
  {
    start: '2026-03-23',
    end: '2026-03-27',
    message1: '本日は通常営業です。',
    message2: 'なお、外出やリモート作業のため担当者が不在の場合がございます。',
    message3: ''
  },
  {
    start: '2026-03-28',
    end: '2026-03-29',
    message1: '本日は休業日です。',
    message2: '',
    message3: ''
  },
  {
    start: '2026-03-30',
    end: '2026-04-03',
    message1: '本日は通常営業です。',
    message2: 'なお、外出やリモート作業のため担当者が不在の場合がございます。',
    message3: ''
  },
  {
    start: '2026-04-04',
    end: '2026-04-05',
    message1: '本日は休業日です。',
    message2: '',
    message3: ''
  },
  {
    start: '2026-04-06',
    end: '2026-04-10',
    message1: '本日は通常営業です。',
    message2: 'なお、外出やリモート作業のため担当者が不在の場合がございます。',
    message3: ''
  },
  {
    start: '2026-04-11',
    end: '2026-04-12',
    message1: '本日は休業日です。',
    message2: '',
    message3: ''
  },
  {
    start: '2026-04-13',
    end: '2026-04-17',
    message1: '本日は通常営業です。',
    message2: 'なお、外出やリモート作業のため担当者が不在の場合がございます。',
    message3: ''
  },
  {
    start: '2026-04-18',
    end: '2026-04-19',
    message1: '本日は休業日です。',
    message2: '',
    message3: ''
  },
  {
    start: '2026-04-20',
    end: '2026-04-24',
    message1: '本日は通常営業です。',
    message2: 'なお、外出やリモート作業のため担当者が不在の場合がございます。',
    message3: ''
  },
  {
    start: '2026-04-25',
    end: '2026-04-26',
    message1: '本日は休業日です。',
    message2: '',
    message3: ''
  },
  {
    start: '2026-04-27',
    end: '2026-04-28',
    message1: '本日は通常営業です。',
    message2: 'なお、外出やリモート作業のため担当者が不在の場合がございます。',
    message3: ''
  },
  {
    start: '2026-04-29',
    end: '2026-04-29',
    message1: '本日は休業日です。',
    message2: '',
    message3: ''
  },
]

const todaySchedules = computed(() => {
  today.setHours(0, 0, 0, 0)

  return schedules.filter(item => {
    const start = new Date(item.start)
    start.setHours(0, 0, 0, 0)

    const end = new Date(item.end)
    end.setHours(23, 59, 59, 999)

    return today >= start && today <= end
  })
})

function top() {
  // 
  location.href = '/';
}
function gotoStaffPage() {
  // 
  return;
}

onMounted(() => {
  const savedLanguage = localStorage.getItem('translate');
  if (savedLanguage !== null) {
    translate.value = JSON.parse(savedLanguage);
  }
});

watch(translate, (newValue) => {
  localStorage.setItem('translate', JSON.stringify(newValue));
});

</script>

<style>
@media (max-width: 667px) {
  .el-calendar__header {
    display: block;
  }
}
</style>

<style scoped>
.is-pc {
  display: block;
}
.is-mobile {
  display: none;
}
.layout-container {
  background-color: #b7b6b31f;
  padding-bottom: 50px;
}
.layout-container .el-header {
  position: relative;
  text-align: left;
}
.layout-container .el-menu {
  border-right: none;
  align-items: center;
}
.layout-container .el-menu-item {
  padding: 0 10px;
}
.menu-column {
  padding: 0 10px;
}
.menu-logo {
  cursor: pointer;
}
.menu-translate {
  width: 100%;
  text-align: right;
}
.layout-container .el-main {
  padding: 0 10px;
  text-align: left;
}
.layout-container .toolbar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  right: 20px;
}
.el-carousel {
  padding: 30px 0;
}
.el-carousel__indicators {
  margin-bottom: 100px;
}
.el-carousel__item h3 {
  color: #f9ffff;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
  text-align: center;
}
.el-carousel__item {
  background-color: #2b3b4d;
  height: unset;
}
.el-calendar {
  width: 500px;
  min-width: 500px;
}
.item-comingsoon-img {
  padding-top: 150px;
}
.item-about-us {
  background: url("../assets/img/top_512.png") no-repeat #6c6364;
  background-color: #2b3b4d;
  height: 500px;
  margin-bottom: 20px;
  overflow: hidden;
}
.item-transactions {
  background: url("../assets/img/office3_875_500.png") no-repeat #6c6364;
  height: 500px;
  margin-bottom: 20px;
}
.item-company-profile {
  background: url("../assets/img/mtg_500.png") no-repeat #6c6364;
  height: 500px;
  margin-bottom: 20px;
  font-size: 0.9rem;
}
.item-support-examples {
  background: url("../assets/img/dev_500.png") no-repeat #6c6364;
  height: 500px;
  margin-bottom: 20px;
}
.item-info {
  margin-top: 30px;
  display: flex;
  align-items: end;
}
.item-info-right {
  display: block;
}
.item-staff-only {
  margin-top: 20px;
  margin-left: 20px;
  text-align: left;
}
.img-staff {
  display: flex;
  align-items: end;
}
.item-other {
  margin-top: 20px;
  text-align: left;
}
.item-other img {
  height: 100px;
}
.item-updated {
  margin: 20px 0;
  font-size: 0.9rem;
  text-align: left;
}
.img-mtg {
  margin: 10px;
  text-align: left;
}
.img-mtg img {
  height: 100px;
}
.img-dev {
  margin: 20px;
  text-align: center;
}
.img-staff img {
  cursor: pointer;
}
.img-staff img:hover {
  opacity: 0.5;
}
.img-staff .el-input {
  margin-left: 10px;
}
p{
  margin: 0;
}
#logo {
  height: 100%;
}
.logo-txt {
  fill: gray;
  stroke: lightgoldenrodyellow;
  stroke-width: 1;
  stroke-linecap: round;
  font-size: 26px;
  font-family: "Yu Gothic UI Light", "Hiragino Kaku Gothic ProN", "Hiragino Sans", "Noto Sans", sans-serif;
}
.logo-animated {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: line-animation 10s linear infinite;
}
.sw-translate {
  margin: 5px
}
.catchphrase {
  margin-top: 40px;
  width: 50%;
  font-family: 'Montserrat', sans-serif;
}

.bird {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    padding: 20px;
}
.speech-bubble {
    background-color: #fff;
    border: 1px solid lightblue;
    border-radius: 10px;
    padding: 10px 20px;
    position: relative;
    margin-left: 20px;
}
.speech-bubble::after {
    content: '';
    position: absolute;
    top: 50%;
    left: -20px;
    transform: translateY(-50%);
    border: 10px solid transparent;
    border-right-color: lightblue;
    border-left: none;
}
.bird-img {
    width: 80px;
    height: auto;
}

footer {
  background-color: #333;
  color: #f9ffff;
  padding: 20px 0;
  text-align: center;
}
.footer-content {
  max-width: 1200px;
  margin: 0 auto;
}
.footer-content h2 {
  margin: 0;
  font-size: 24px;
  font-weight: bold;
}
.footer-content p {
  margin: 10px 0;
  font-size: 14px;
}

@keyframes line-animation {
  0%   { stroke-dashoffset: 0; }
  25%  { stroke-dashoffset: 1000; }
  50%  { stroke-dashoffset: 1000; }
  75%  { stroke-dashoffset: 1000; }
  100% { stroke-dashoffset: 1000; }
}

@media (max-width: 667px) {
  .is-pc {
    display: none;
  }
  .is-mobile {
    display: block;
  }
  .item-transactions {
    background: url("../assets/img/office3_520_500.png") no-repeat #6c6364;
  }
  .item-info {
    display: block;
  }
  .el-calendar {
    width: 90%;
    min-width: unset;
    margin-left: 5%;
  }
  .el-calendar__header {
    display: block;
  }
  .catchphrase {
    width: 90%;
  }
  .bird {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    position: relative;
    padding: 10px;
  }
  .bird-img {
    width: 50px;
    height: auto;
  }
}
</style>
